const http = (o) => /^https?.*/.test(o)

const is = { http }
export { is }
